/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const __vue_script__ = {

  /** @since 3.11.0 */
  name: 'modal-login',
  data() {
    return {
      show: false,
    }
  },

  computed: {

    login_url() {
      return 'localhost:3000' === window.location.host
        ? (new URL(`/#/${window.g3w.state.language}/login`, initConfig.baseurl)).toString()
        : window.initConfig.user.login_url;
    },

  },

  methods: {

     onIframeLoaded(e) {
      const iframe = this.$refs.login_iframe?.contentWindow?.g3wsdk?.core?.ApplicationState;
      if (iframe?.user?.logout_url) {
        this.show = false;
        window.location.reload();
      }
    },

  },

  async mounted() {
    document.body.appendChild(this.$el);
    await this.$nextTick();
    this.show = true;
  }

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('dialog',{staticStyle:{"width":"min(85vw, 600px)"},attrs:{"id":"modal-login","aria-label":_vm.$t('sign_in')}},[_c('form',{staticStyle:{"height":"60vh","padding":"0"},attrs:{"method":"dialog"}},[_c('button',{staticStyle:{"border":"none","line-height":"1","font-weight":"700","font-size":"25px","background":"none","position":"absolute","inset":"0 0 auto auto","width":"40px","height":"40px"},attrs:{"value":"cancel"}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticStyle:{"height":"100%","background":"#d2d6de","display":"grid","grid-template-areas":"'iframe'","place-items":"center"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:('Loading ...'),expression:"'Loading ...'"}],staticStyle:{"grid-area":"iframe"}}),_vm._v(" "),_c('iframe',{ref:"login_iframe",staticStyle:{"border":"0","width":"100%","height":"100%","grid-area":"iframe"},attrs:{"loading":"lazy","src":_vm.login_url,"title":"login form"},on:{"load":_vm.onIframeLoaded}})])])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ModalLogin.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__